import store from '@/store.js'
import axios from 'axios'

export default {
  install: Vue => {
    var services = {
      LOGIN: 'login',
      LOGOUT: 'logout',
      UPLOAD: 'upload',
      UPLOAD_WITH_LOADER: 'upload',
      SELECT: 'select',
      TAGS: 'tags',
      APP_VERSION: 'app/version',
      USER_PROFILE: 'user/profile',
      UPLOAD_VOTERS: 'upload-voters',
      EVENTS: 'events',
      USERS: 'users',
      EXCEL: 'excel',
      TRANSLATIONS: 'translations',
      PASSWORD_RESET: 'password-reset',
      UNSUBSCRIBE: 'unsubscribe',
      SUPPORT: 'support',
      ACCOUNT_UNLOCK: 'account-unlock',
      ACCEPT_TERMS: 'accept-terms',
      PURCHASE: 'purchase',
      TFA: 'tfa',
      DOCUMENTS: 'documents',
      MESSAGES: 'messages',
      QUESTIONS: 'questions',
      CLEAR_TOKEN_COOKIE: 'clear-token-cookie',
      COOKIE_TOKEN: 'cookie/token',
      REPORT_WASNT_ME: 'report/wasnt-me',
    }

    Vue.prototype.$APILogin = function (
      data,
      responseCall,
      handle_errors = null
    ) {
      var properties = {
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/${services['LOGIN']}`,
        json: true,
        data: data,
        withCredentials: true,
      }

      store.commit('increaseLoaderCount')

      axios(properties)
        // Success.
        .then(response => {
          if (response.data.success) {
            if (!response.data.tfa) {
              store.dispatch('setLoggedIn', true).then(() => {
                this.$i18n.locale = response.data.user.language
              })
            }
          }

          responseCall(response.data)
        })
        // Error handling.
        .catch(error => {
          if (handle_errors !== null) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx.
            handle_errors(error)
          } else {
            // This prevents the loader from dissapearing, making the website unusable until refreshed.
            throw new Error(error)
          }
        })
        // Always executed.
        .then(() => {
          store.commit('decreaseLoaderCount')
        })
    }

    Vue.prototype.$APILogout = async function () {
      return axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/${services['LOGOUT']}`,
        json: true,
        data: [],
        withCredentials: true,
      }).then(() => {
        store.dispatch('setLoggedIn', false)
      })
    }

    Vue.prototype.$APICall = async function (
      method,
      service,
      addition,
      data,
      responseCall,
      showLoader = true,
      handle_errors = null
    ) {
      var properties = {
        method: method,
        url: `${process.env.VUE_APP_API_URL}/${services[service]}${addition}`,
        json: true,
        withCredentials: true,
      }

      if (method == 'put' || method == 'post' || method == 'patch') {
        properties.data = data
      } else {
        properties.params = data
      }

      if (showLoader) {
        store.commit('increaseLoaderCount')
      }

      return (
        axios(properties)
          // Success.
          .then(response => {
            if (response.status == 200) {
              responseCall(response.data)
            }
          })
          // Error handling.
          .catch(error => {
            if (handle_errors !== null) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx.
              handle_errors(error)
            } else {
              // This prevents the loader from dissapearing, making the website unusable until refreshed.
              // throw new Error(error)
              return Promise.reject(error)
            }
          })
          // Always executed.
          .then(() => {
            if (showLoader) {
              store.commit('decreaseLoaderCount')
            }
          })
      )
    }

    Vue.prototype.$APIUpload = function (
      file,
      responseCall,
      service = 'UPLOAD',
      addition = null,
      handle_errors = null
    ) {
      let formData = new FormData()

      formData.append('file', file)

      if (addition != null) {
        for (let key in addition) {
          formData.append(key, addition[key])
        }
      }

      if (service != 'UPLOAD') {
        store.commit('increaseLoaderCount')
      }

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/${services[service]}`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      })
        .then(response => {
          if (response.status == 200) {
            responseCall(response.data)
          }
        })
        // Error handling.
        .catch(error => {
          if (handle_errors !== null) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx.
            handle_errors(error)
          } else {
            // This prevents the loader from dissapearing, making the website unusable until refreshed.
            throw new Error(error)
          }
        })
        // Always executed.
        .then(() => {
          if (service != 'UPLOAD') {
            store.commit('decreaseLoaderCount')
          }
        })
    }
  },
}
